import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { FiPlay, FiSquare } from 'react-icons/fi';

interface HydrationControlsProps {
  isAutoHydrating: boolean;
  selectedNodesCount: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
  onStartAutoHydration: () => void;
  onStopAutoHydration: () => void;
}

export const HydrationControls: React.FC<HydrationControlsProps> = ({
  isAutoHydrating,
  selectedNodesCount,
  onSelectAll,
  onClearSelection,
  onStartAutoHydration,
  onStopAutoHydration
}) => {
  const { darkMode } = useTheme();

  return (
    <div className="flex space-x-1">
      {/* More compact buttons */}
      {isAutoHydrating ? (
        <button
          className={`px-2 py-0.5 rounded text-xs font-medium ${
            darkMode ? 'bg-red-700 hover:bg-red-600 text-white' : 'bg-red-500 hover:bg-red-600 text-white'
          }`}
          onClick={onStopAutoHydration}
          title="Stop auto-hydration"
        >
          <FiSquare className="inline mr-1" size={10} />
          Stop ({selectedNodesCount})
        </button>
      ) : (
        <button
          className={`px-2 py-0.5 rounded text-xs font-medium ${
            selectedNodesCount === 0
              ? darkMode 
                ? 'bg-gray-700 text-gray-500 cursor-not-allowed' 
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : darkMode 
                ? 'bg-green-700 hover:bg-green-600 text-white' 
                : 'bg-green-500 hover:bg-green-600 text-white'
          }`}
          onClick={onStartAutoHydration}
          disabled={selectedNodesCount === 0}
          title="Start auto-hydration for selected nodes"
        >
          <FiPlay className="inline mr-1" size={10} />
          Start ({selectedNodesCount})
        </button>
      )}
    </div>
  );
};
